import { connect } from "react-redux"
import { Dispatch } from "redux"
import { updateUserInfo } from "../../actions/loginDataActionCreator"
import { updateSwitchingUserInfo } from "../../actions/switchingUserActionCreator"
import { getCurrentUser } from "../../libs/get-current-user"
import { RootState, ReduxAction } from "../../reducers"
import { User } from "../../rpcs/dist/UserRPC"

export interface IContainerProps {
  currentUser: User | null
  isUserSwitching: boolean
  actions: ActionDispatcher
}

export class ActionDispatcher {
  constructor(private dispatch: (action: ReduxAction) => void) {}

  public updateUserInfo(user: User) {
    this.dispatch(updateUserInfo({ user }))
  }

  public updateSwitchingUserInfo(user: User) {
    this.dispatch(updateSwitchingUserInfo(user))
  }
}

const mapStateToProps = ({
  loginData,
  switchingUser,
}: RootState): Omit<IContainerProps, "actions"> => ({
  currentUser: getCurrentUser(loginData, switchingUser),
  isUserSwitching: !!(switchingUser.token && switchingUser.debug),
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: new ActionDispatcher(dispatch),
})

export const container = connect(mapStateToProps, mapDispatchToProps)
